<form class="w-100" #form="ngForm" (ngSubmit)="validateLeagueValues(form)">
    <p class="error-message" *ngIf="parentError">{{ parentError }}</p>
    <div class="input-group">
        <label for="fn">League Name <span class="required-indicator">*</span></label>
        <input type="text" [(ngModel)]="newLeague.league_name" id="fn" required name="league_name" [disabled]="parentLoading"
            class="textbox p-10">
        <div *ngIf="form.submitted && form.controls.league_name?.invalid">
            <small class="error-message">League Name is required</small>
        </div>
    </div>

    <div class="flex gap-2 w-100">
        <div class="input-group w-100">
            <label for="start">Start Date <span class="required-indicator">*</span></label>
            <input type="date" [(ngModel)]="newLeague.league_start" [disabled]="parentLoading" id="start" required name="league_start"
                class="textbox p-10">
            <div *ngIf="form.submitted && form.controls.league_start?.invalid">
                <small class="error-message">League Start Date is required</small>
            </div>
        </div>

        <div class="input-group w-100">
            <label for="end">End Date <span class="required-indicator">*</span></label>
            <input type="date" [(ngModel)]="newLeague.league_end" id="end" [disabled]="parentLoading" required name="league_end"
                class="textbox p-10">
            <div *ngIf="form.submitted && form.controls.league_end?.invalid">
                <small class="error-message">League End Date is required</small>
            </div>
        </div>
    </div>

    <div class="input-group">
        <label for="game_type">Game Type <span class="required-indicator">*</span></label>
        <select class="textbox p-10" id="game_type" name="game_type" required [(ngModel)]="newLeague.game_type" [disabled]="parentLoading">
            <option *ngFor="let gameType of gameTypes" [value]="gameType.code_name">{{ gameType.name }}</option>
        </select>
        <div *ngIf="form.submitted && form.controls.game_type?.invalid">
            <small class="error-message">Game Type is required</small>
        </div>
    </div>

    <div class="input-group">
        <label for="scoring_type">Scoring Type <span class="required-indicator">*</span></label>
        <select class="textbox p-10" id="scoring_type" name="scoring_type" required [(ngModel)]="newLeague.scoring_type" [disabled]="parentLoading">
            <option value="total_score">Total Score</option>
            <option value="total_tba">Cumulative TBA</option>
            <option value="average_score">Average Score</option>
            <option value="average_tba">Overall TBA</option>
        </select>
        <div *ngIf="form.submitted && form.controls.scoring_type?.invalid">
            <small class="error-message">Scoring Type is required</small>
        </div>
    </div>

    <div class="flex gap-2 w-100">
        <div class="input-group w-100">
            <label for="min_game">Minimum Games to Qualify <span class="required-indicator">*</span></label>
            <input type="number" [(ngModel)]="newLeague.min_game" id="min_game" required name="min_game" [disabled]="parentLoading"
                class="textbox p-10">
            <div *ngIf="form.submitted && form.controls.min_game?.invalid">
                <small class="error-message">Minimum Games to Qualify is required</small>
            </div>
        </div>

        <div class="input-group w-100">
            <label for="max_game">Number of Top Scores <span class="required-indicator">*</span></label>
            <input type="number" [(ngModel)]="newLeague.max_game" id="max_game" required name="max_game" [disabled]="parentLoading"
                class="textbox p-10">
            <div *ngIf="form.submitted && form.controls.max_game?.invalid">
                <small class="error-message">Number of Top Scores is required</small>
            </div>
        </div>
    </div>

    <div class="input-group">
        <label for="description">League Description</label>
        <quill-editor 
            class="content-editor" 
            [placeholder]="''"
            [modules]="quillConfiguration"
            [(ngModel)]="newLeague.description"
            [ngModelOptions]="{standalone: true}"> </quill-editor>
    </div>

    <div class="input-group">
        <label for="league_type">League Type</label>
        <select class="textbox p-10" id="league_type" name="league_type" required [(ngModel)]="league_type" (change)="conformLeagueValues($event.target.value)" [disabled]="parentLoading">
            <option *ngFor="let leagueType of leagueTypes" [value]="leagueType">{{ leagueType }}</option>
        </select>
    </div>

    <div *ngIf="league_type === 'City' && !newLeague.city" class="input-group">
        <app-typeahead *ngIf="!loading; else loadingMsg" class="no-flex" [clearOnItemSelect]="true" [itemTypeID]="'city-lookup'"
            (itemSelected)="handleCitySelect($event)" [placeholder]="'Search by name'"></app-typeahead>
    </div>

    <div *ngIf="newLeague.city">
        <h3>{{ newLeague.city }}, {{ newLeague.state }}</h3>
        <div class="flex gap-2 w-100">
            <div class="input-group w-100">
                <label for="distance">League Radius in KM<span class="required-indicator">*</span></label>
                <input type="number" [(ngModel)]="newLeague.distance" id="distance" name="distance" class="textbox p-10" required [disabled]="parentLoading">
                <div *ngIf="form.submitted && form.controls.distance?.invalid">
                    <small class="error-message">League Radius is required</small>
                </div>
            </div>
            <div>
                <button type="button" class="back-button save-button" (click)="clearCity()">Clear</button>
            </div>
        </div>
        
    </div>

    <div *ngIf="league_type === 'State'" class="input-group">
        <label for="state">State Code</label>
        <input type="text" [maxlength]="2" [(ngModel)]="newLeague.state" name="state" id="state" [disabled]="parentLoading"
            class="textbox p-10">
        <div *ngIf="form.submitted && form.controls.state?.invalid">
            <small class="error-message">State Code is required</small>
        </div>
    </div>

    <div *ngIf="league_type === 'Venue-Based'" class="input-group">
        <app-typeahead class="no-flex" [clearOnItemSelect]="true" [itemTypeID]="'venue'"
            (itemSelected)="handleVenueSelect($event)" [placeholder]="'Search by name'"></app-typeahead>
        <div *ngIf="selectedVenues.length" class="list-container no-tp">
            <div *ngFor="let venue of selectedVenues" class="list-item chosen-venue">{{venue.name}}<span (click)="removeVenue(venue)" class="material-icons">delete</span></div>
        </div>
    </div>

    <p class="success-message" *ngIf="successMessage !== ''">{{ successMessage }}</p>
    <p class="error-message" *ngIf="err">{{ err }}</p>
    <div class="flex gap-2 w-100">
        <button type="submit" class="back-button w-100 save-button">
            {{ parentLoading ? 'Saving...': 'Save League' }}
        </button>
        <button *ngIf="isLeagueEdit" type="button" class="back-button w-100 cancel-button" (click)="emitCancelLeague()">
            Cancel
        </button>
    </div>
    
</form>

<ng-template #loadingMsg>
    <p>One moment...</p>
</ng-template>
